<template>
<!--分学银行-->
  <div class="content">
    <headers></headers>
    <div class="nav">
      <div class="auto">行业证书  >  操作指南  >  证书信息登记 </div>
    </div>
    <div class="auto padding250">
       <p class="title">证书信息登记</p>
      <div class="container ">
        <img src="../../assets/shenhe2.png" alt="">
         <p class="desc">抱歉，未查到相关证书请登记证书</p>
          <p class="tip">登记提醒：各地方协会颁发的证书需手动登记证书信息，登记之后可进行换证操作。</p>
           <router-link to="/dengji">证书登记</router-link>
      </div>
    </div>
    <footers></footers>
  </div>
</template>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less" rel="stylesheet/less">


  .nav{
    color: #fff;
    background-color: #2F261E;
    height: 60px;
    line-height: 60px;
    font-size: 16px;
  }
  .content{
    background-color: #f5f5f5;
    text-align: left;
    .title{
      font-size: 26px;
      color: #000;
      margin-top: 30px;
    }
    .container{
      background-color: #fff;
      padding: 50px 30px;
      margin-top: 10px;
      text-align: center;
      .desc{
        font-size: 18px;
        color: #666;
        margin: 0 auto;
        width: 180px;
      }
      .tip{
        font-size: 14px;
        color: #999;
        margin: 40px 0;
      }
      a{
        color: #fff;
        display: inline-block;
        width: 220px;
        height: 50px;
        line-height: 50px;
        text-align: center;
        border-radius: 5px;
        font-size: 16px;
        background-color: #AA9480;
      }
    }
  }
</style>
<script type="text/ecmascript-6">
  import headers from '../template/header'
  import footers from '../template/footer'

    export default {
        name: 'fenxue',
        props: {},
        data() {
            return {};
        },
        methods: {},
        created() {

        },
        components: {
          headers,
          footers

        }
    }
</script>



// WEBPACK FOOTER //
// src/components/certificate/chaxun.vue